(function () {
  "use strict";

  /**
   * @memberof page-builder
   * @constructs Dialog
   */
  var Dialog = {
    /**
     * @name show
     * @description
     *  Show a sweet alert with the supplied parameters and optional callback.
     * @see http://t4t5.github.io/sweetalert/
     * @param {object} opts
     * @param {function} callback
     */
    show: function (opts, callback) {
      // if the sweet alert functionality is not available, we do not want
      //  to throw an error, so we squelch the functionality.
      if (typeof window.swal === "undefined") {
        return;
      }

      /**
       * @todo
       * So ideally, we can set some generic defaults here depending on what
       *  theme we want, and other stuff. For now, I am just going to ignore this
       *  since we can just trigger it ad-hoc.
       */

      // passthrough to the sweet alert wrapper. we tween the display with
      //  set timeout so that if multiple are in sequence they dont crap
      //  each other out.
      setTimeout(function () {
        var customContent = [];

        // it looks like sweet alert is reusing the existing alert element.
        // so we need to be careful to manually remove any extra
        // elements we've added.
        function teardownCustomContent() {
          jQuery.each(customContent, function () {
            this.remove();
          });
        }

        swal(opts, function (value) {
          if (callback) {
            // Emulate sweet alert's behaviour of checking the arity of a function to see if we should run it if the
            // value is falsey. If the function accepts an arg, then always call it and allow it to determine what to do.
            // Else, it is a function that only runs if we confirmed the modal.
            if (callback.length) {
              callback(value);
            } else if (value) {
              callback();
            }
          }
          teardownCustomContent();
        });

        // sweet alert only provides support for a primary confirmation
        // button and a cancel button, so any additional buttons we're
        // left implementing them ourselves.
        if (opts.secondaryButtonText) {
          var sweetAlert = jQuery(".sweet-alert:visible");
          // to mimic their styling, we're going to copy the existing
          // cancel button. we're also going to use this button for
          // positioning our extra button.
          var cancelButton = sweetAlert.find(".sa-button-container button.cancel");
          var newButton = cancelButton.clone();

          // now we need to configure our newly cloned button.
          newButton.removeClass("cancel");
          newButton.addClass("secondary");
          newButton.html(opts.secondaryButtonText);

          newButton.on("click", function () {
            // if a callback was provided.
            if (opts.secondaryButtonCallback) {
              opts.secondaryButtonCallback();
            }

            swal.close();
            teardownCustomContent();
          });

          // after we're done, we add it to the sweet alert.
          newButton.insertAfter(cancelButton);
          customContent.push(newButton);
        }
      }, 250);
    },
  };

  // export
  _.extend(Sparkle.PageBuilder, { Dialog: Dialog });
})();
